import { categoriesGroupedByGroupSelector } from "./categoriesGroupedByGroupSelector";
import { RootState } from "../../store";
import { sortAlphabeticallyCallback } from "../../../utils/helpers/sorting";

export const categoryNamesAlphabeticallySortedSelector = (state: RootState) => {
  const groupedCategories = categoriesGroupedByGroupSelector(state);

  return Object.keys(groupedCategories).sort(sortAlphabeticallyCallback);
};
